import { Datagrid, FunctionField, List, Pagination } from "react-admin";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { RaRowActions } from "../../components/RaRowActions";
import { AppBulkDeleteButton } from "../../components/AppBulkDeleteButton";
import { colors, radius, shadows } from "../../data/tokens";
import { transactionCategoryColor } from "../transactions/transactions-util";

// Bolinha colorida + nome — mesmo desenho do CategoryDot das Categorias
// de Sócios, usando as famílias de cor das categorias de transação
const TransactionCategoryDot = ({ name }: { name?: string }) => {
  if (!name) return null;
  const color = transactionCategoryColor(name);
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Box
        sx={(theme: any) => ({
          width: 10,
          height: 10,
          borderRadius: "50%",
          flexShrink: 0,
          backgroundColor:
            color === "default"
              ? colors.neutral300
              : theme.palette[color].main,
        })}
      />
      <Typography
        sx={{ fontSize: 13.5, fontWeight: 600, color: colors.primaryDark }}
      >
        {name}
      </Typography>
    </Box>
  );
};

// Tela simples (9 categorias fixas): sem busca/exportação — o "Novo" do
// breadcrumb cobre a criação. Padrão espelhado das Categorias de Sócios:
// clicar na linha abre a ficha; Editar/Excluir visíveis (antes ficavam
// escondidos atrás do menu "⋮").
export const TransactionCategoryList = () => {
  return (
    <>
      <PageTopBreadcrumb
        title="Categorias de Transações"
        firstPath="/#/transaction-categories/crud"
        actionType="create"
      />
      <List
        actions={false}
        perPage={20}
        pagination={<Pagination rowsPerPageOptions={[10, 20, 50]} />}
        queryOptions={{ keepPreviousData: true }}
        sx={{
          "& .RaList-main": {
            backgroundColor: colors.white,
            borderRadius: `${radius.lg}px`,
            boxShadow: shadows.card,
            padding: "12px 20px 8px",
          },
          "& .RaList-content": {
            boxShadow: "none",
            backgroundColor: "transparent",
          },
        }}
      >
        <Datagrid
          rowClick="show"
          bulkActionButtons={<AppBulkDeleteButton />}
          sx={{
            "& .RaDatagrid-headerCell": {
              fontSize: 11.5,
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: "0.04em",
              color: colors.textMuted,
              backgroundColor: colors.bgSubtle,
              paddingTop: 1,
              paddingBottom: 1,
            },
            "& .RaDatagrid-rowCell": { paddingTop: 0.75, paddingBottom: 0.75 },
          }}
        >
          <FunctionField
            label="Categoria"
            sortBy="name"
            render={(record: any) => (
              <TransactionCategoryDot name={record.name} />
            )}
          />
          <FunctionField
            label="Ações"
            textAlign="right"
            render={() => <RaRowActions />}
          />
        </Datagrid>
      </List>
    </>
  );
};
